import React from 'react';
import alarmSuppressionFields from './alarmSuppressionFields';

const { startTime, expirationTime, neverExpire } = alarmSuppressionFields;

export default function agentConfigFields(universalAgentModel) {
  return {
    agent_alias: {
      label: 'Name',
      rules: 'required',
      placeholder: 'Agent Alias',
      defaultValue: 'name',
      disabled: !!universalAgentModel,
      helpText: 'Agent name is inherited from the Universal Agent name and cannot be edited directly.'
    },
    agent_status: {
      label: 'Status',
      defaultValue: 'WAIT',
      options: [
        { value: 'WAIT', label: 'WAIT' },
        { value: 'OK', label: 'OK' }
      ]
    },
    site_id: {
      label: 'Site',
      rules: 'required',
      defaultValue: 0,
      disabled: !!universalAgentModel,
      helpText:
        "This agent's site is inherited from the Universal Agent Site. To change it, update the Universal Agent Site settings."
    },

    'site.title': {
      label: 'Name'
    },
    'site.address': {
      label: 'Street Address',
      helpText: 'We will geocode this address and provide additional Geographic dimensions that involve this'
    },
    'site.country': {
      label: 'Country',
      defaultValue: ''
    },
    'site.city': {
      label: 'City'
    },
    'site.region': {},
    'site.postal': {},
    'site.lat': {},
    'site.lon': {},
    'site.metadata': {
      defaultValue: {}
    },
    'metadata.broadband': {
      label: 'Broadband Agent',
      defaultValue: false
    },
    'metadata.static_ipv4': {
      label: 'Static IPv4',
      helpText: "The agent's public IPv4 address does not change.",
      defaultValue: false
    },
    'metadata.static_ipv6': {
      label: 'Static IPv6',
      helpText: "The agent's public IPv6 address does not change.",
      defaultValue: false
    },
    'metadata.cloud_provider': {
      label: 'Cloud Provider'
    },
    'metadata.cloud_region': {
      label: 'Cloud Region'
    },
    'metadata.cloud_vpc': {
      label: 'Cloud Virtual Network'
    },
    'metadata.private_ipv4_addresses': {
      isComplexArray: true
    },
    'metadata.private_ipv4_addresses[].value': {
      label: 'Private IPv4',
      rules: 'ipv4|ipNoCidr'
    },
    'metadata.private_ipv6_addresses': {
      isComplexArray: true
    },
    'metadata.private_ipv6_addresses[].value': {
      label: 'Private IPv6',
      rules: 'ipv6|ipNoCidr'
    },
    'metadata.public_ipv4_addresses': {
      isComplexArray: true
    },
    'metadata.public_ipv4_addresses[].value': {
      label: 'Public IPv4',
      rules: 'ipv4|ipNoCidr'
    },
    'metadata.public_ipv6_addresses': {
      isComplexArray: true
    },
    'metadata.public_ipv6_addresses[].value': {
      label: 'Public IPv6',
      rules: 'ipv6|ipNoCidr'
    },
    'metadata.ua_id': {},
    os: {
      label: 'Operating System',
      placeholder: 'Agent OS'
    },
    lat: {
      label: 'Latitude',
      rules: 'required|numeric|between:-90,90',
      placeholder: 'Agent Latitude',
      defaultValue: 0
    },
    long: {
      label: 'Longitude',
      rules: 'required|numeric|between:-180,180',
      placeholder: 'Agent Longitude',
      defaultValue: 0
    },
    challenge: {
      rules: 'size:64'
    },
    country: {
      label: 'Country',
      defaultValue: ''
    },
    region: {},
    city: {
      label: 'City'
    },
    agent_labels: {
      label: 'Labels',
      defaultValue: [],
      placeholder: 'Apply labels to this agent...'
    },
    agent_family: {
      defaultValue: 'DUAL',
      label: 'IP Versions Supported',
      options: [
        {
          value: 'DUAL',
          label: 'v4 + v6'
        },
        {
          value: 'v4',
          label: 'v4 only'
        },
        {
          value: 'v6',
          label: 'v6 only'
        }
      ]
    },
    agent_alert_rule_status: {
      label: <strong>Downtime Alerting</strong>,
      default: true,
      helpText: 'Enable alerts for agent issues. Status checks run every 30 seconds.'
    },
    'agent_alert_rule_config.alertingRuleId': {
      default: ''
    },
    'agent_alert_rule_config.thresholds[0].thresholdSeconds': {
      default: 5,
      rules: 'AreAgentAlertThresholdsLongEnough|AreAgentAlertThresholdsIntegers'
    },
    'agent_alert_rule_config.thresholds[0].thresholdType': {
      default: 'seconds',
      options: [
        {
          value: 'minutes',
          label: 'minutes'
        },
        {
          value: 'seconds',
          label: 'seconds'
        }
      ]
    },
    notificationChannels: {
      defaultValue: []
    },
    'agent_alert_rule_config.suppression.enabled': {
      label: <strong>Maintenance Mode</strong>,
      defaultValue: false,
      helpText:
        'Temporarily pause data collection and alerts for tests using this agent. This includes downtime status alerts.'
    },
    'agent_alert_rule_config.suppression.suppressionId': {
      defaultValue: ''
    },
    'agent_alert_rule_config.suppression.suppressionIds': {
      defaultValue: []
    },
    'agent_alert_rule_config.suppression.startTime': startTime,
    'agent_alert_rule_config.suppression.endTime': expirationTime,
    'agent_alert_rule_config.suppression.neverExpire': neverExpire,
    'agent_alert_rule_config.suppression.legacySuppressionIds': {
      defaultValue: []
    }
  };
}
